import styled from "styled-components";

export const RadioButton = styled.input`
  width: 1em;
  height: 1rem;
  accent-color: #00697c;
  margin-right: 5px;
`;
export const SectionTitle = styled.div`
  font-size: 1.2rem;
  margin-bottom: 15px;
  margin-top: 15px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  align-items: center;
`;
